/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import Logo from '../../images/logo.svg';
import { Footer } from '@g17eco/molecules/footer';

export function renderContainer(headerTop: JSX.Element, actions: JSX.Element) {
  return (
    <div className='direct'>
      <div className='directWrapper'>
        <header>
          {headerTop}
          <div className='headerBottom'>
            <img className='logo' src={Logo} alt='G17Eco' />
          </div>
        </header>
        <div className='directBodyContainer'>
          <div className='offset-md-3 col-sm-12 col-md-6'>{actions}</div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
